export enum AdvancedSearchBoolInput {
  MISSING_DESIGN = 'missingDesign',
  NOT_IN_GROUP = 'notInGroup'
}
